import * as Yup from "yup";

export const snapshotSchema = Yup.object().shape({
  windowStartDate: Yup.string().required("Start Date is required"),
  windowEndDate: Yup.string().required("End Date is required"),
});
